import { Component, computed, input, output, viewChild } from '@angular/core';
import { MatAutocomplete, MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { staticPrompts } from 'src/app/eva-sidebar/eva-suggested-prompts/eva-page-prompt-rules';

@Component({
  selector: 'ez-eva-suggested-prompts',
  imports: [MatAutocompleteModule, MatIconModule],
  templateUrl: './eva-suggested-prompts.component.html',
  styleUrl: './eva-suggested-prompts.component.scss',
})
export class EvaSuggestedPromptsComponent {

  /** Page and AI prompts, already gated for visibility by EvaSuggestedPromptsService. */
  protected readonly prompts = input.required<string[]>();

  /** Whether the generic hints belong in the list — new chat only. */
  protected readonly showStaticPrompts = input(false);

  /** Static prompts to hide, e.g. ones the current page's own prompts duplicate. */
  protected readonly excludedStaticPrompts = input<readonly string[]>([]);

  /** What the agent has typed, used to filter the list. */
  protected readonly query = input('');

  protected readonly promptSelected = output<string>();

  /**
   * The panel, targeted by the chat textarea's MatAutocompleteTrigger. This must stay a *signal*
   * query: the parent binds `[matAutocomplete]="suggested.panel()"`, and only a signal query
   * resolves early enough for that binding's first evaluation. The @ViewChild form is populated at
   * ngAfterViewInit and would raise NG0100.
   */
  readonly panel = viewChild.required(MatAutocomplete);

  /** Custom prompts first, then the hints. Case-insensitive substring match on the whole prompt. */
  protected readonly options = computed(() => {
    const query = this.query().toLowerCase();
    const excluded = this.excludedStaticPrompts();
    const visibleStaticPrompts = this.showStaticPrompts()
      ? staticPrompts.filter(prompt => !excluded.includes(prompt))
      : [];
    const all = [...this.prompts(), ...visibleStaticPrompts];
    return query ? all.filter(prompt => prompt.toLowerCase().includes(query)) : all;
  });

  protected onOptionSelected(prompt: string): void {
    this.promptSelected.emit(prompt);
  }
}
